import React from "react";
import { TableHead, Typography, Grid2 as Grid, useTheme } from "@mui/material";
import { TableCell } from "@mui/material";
import { TableBody, TableRow } from "@mui/material";
import { ExternalLink } from "../../../components/ExternalLink";
import { TableContainer } from "@mui/material";
import { StyledTable } from "../../Chasables/styled";
import { calculateOverdueColorHex } from "../../../services/helpers";
import { InvoiceStatusComponent } from "../../../components/InvoiceStatus";
import { formatDate } from "../../../utils/formatDate";
import { formatAmount } from "../../../utils/formatAmount";
import { InvoiceStatus } from "../../../models/ChasableModels";
import { useNavigate } from "react-router-dom";
import { SearchResponseModel } from "../../../models/SearchModels";
import { usePayablesBySupplierOrId } from "../../../hooks/usePayablesBySupplierOrId";
import { InvoiceTotalInfo } from "../../../components/InvoiceTotalInfo";

const SearchPayableList: React.FC<{ value: SearchResponseModel }> = ({ value }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const navigate = useNavigate();
  const { invoices, totalInfo, supplierId } = usePayablesBySupplierOrId(value);
  const validInvoices =
    invoices?.filter(({ status }) => {
      return status !== InvoiceStatus.DELETED && status !== InvoiceStatus.VOIDED;
    }) ?? [];

  const onInvoiceClick = (event: React.MouseEvent<HTMLElement, MouseEvent>, invoiceId: string) => {
    event.preventDefault();
    if (!supplierId) return;
    navigate(`/payables/${supplierId}/${invoiceId}?isFromSearch=true&showBackButton=true`);
  };

  return (
    <>
      {totalInfo && (
        <InvoiceTotalInfo
          totalAmount={totalInfo.totalAmount}
          totalDueAmount={totalInfo.totalDueAmount}
          link={totalInfo.link}
        />
      )}
      <Grid size={12} borderRadius="4px" border="1px solid #c7c7c7" overflow="hidden">
        <TableContainer
          className="123"
          sx={{
            "tr > th:last-of-type,td:last-of-type": { pr: 2 },
            backgroundColor: isDarkMode ? "common.black" : "common.white",
          }}
        >
          <StyledTable size="small" aria-label="invoice table">
            <TableHead>
              <TableRow>
                <TableCell>Invoice</TableCell>
                <TableCell align="right">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {validInvoices.map((invoice) => {
                return (
                  <TableRow
                    key={invoice.id}
                    onClick={(e) => onInvoiceClick(e, invoice.id)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "grey.100" } }}
                  >
                    <TableCell>
                      <Grid container alignItems="center">
                        <Grid>
                          <ExternalLink href={invoice.link}>{invoice.invoiceNumber}</ExternalLink>
                          <Typography>{formatAmount(invoice.amount, invoice.currency)}</Typography>
                        </Grid>
                      </Grid>
                    </TableCell>
                    <TableCell align="right">
                      {invoice.dueDate && (
                        <>
                          <Typography>Due {formatDate(invoice.dueDate)}</Typography>
                          <InvoiceStatusComponent
                            color={isDarkMode ? undefined : calculateOverdueColorHex(new Date(invoice.dueDate))}
                            invoice={{
                              dueDate: invoice.dueDate,
                              status: invoice.status as InvoiceStatus,
                            }}
                          />
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </Grid>
    </>
  );
};

export default SearchPayableList;
